import React from "react";

const Bone = ({ className }: { className: string }) => (
  <div className={`bg-gray-100 dark:bg-neutral-600 rounded-lg animate-pulse ${className}`} />
);

const AuthSkeleton: React.FC = () => {
  return (
    <div className="w-full">
      {/* Logo */}
      <div className="flex justify-center mb-5">
        <Bone className="h-10 w-36" />
      </div>

      {/* Heading + subtitle */}
      <div className="mb-5 space-y-2">
        <Bone className="h-6 w-40" />
        <Bone className="h-3.5 w-56" />
      </div>

      {/* Tab toggle */}
      <Bone className="h-10 w-full mb-5 !rounded-[10px]" />

      {/* Email field */}
      <Bone className="h-[52px] w-full mb-3 !rounded-[10px]" />

      {/* Password field */}
      <Bone className="h-[52px] w-full mb-4 !rounded-[10px]" />

      {/* reCAPTCHA */}
      <Bone className="h-[78px] w-full mb-4 !rounded-[10px]" />

      {/* Submit button */}
      <div className="h-11 w-full rounded-xl bg-primary-100 animate-pulse mb-4" />

      {/* Footer link */}
      <div className="flex justify-center">
        <Bone className="h-3 w-48" />
      </div>
    </div>
  );
};

export default AuthSkeleton;
